import React, { useEffect, useState } from 'react';
import axios from 'axios';
import css from './DashboardListingWrapper.module.css';
import classnames from 'classnames';

import { withRouter } from 'react-router-dom';
import { useIntl } from 'react-intl';

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

import config from '../../../config';
import DashboardAddButton from '../../elements/dashboard-add-button/DashboardAddButton';
import ProfileCard from '../../elements/profile-card/ProfileCard';
import UpgradeRequiredModal from '../../elements/upgrade-required-modal/UpgradeRequiredModal';

import {
  faEdit,
  faShare,
  faTrash,
  faLock,
  faLockOpen,
  faExclamationTriangle,
  faQuestionCircle,
  faPlusSquare,
} from '@fortawesome/free-solid-svg-icons';

import { types as sdkTypes } from '../../../util/sdkLoader';

import IconSpinner from '../../../components/IconSpinner/IconSpinner';

import DefaultListing from '../../../assets/default-listing.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { formatDateDisplay } from '../../../util/dateDisplay';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { closeNotification, showNotification } from '../../../custom-ducks/utility.duck';
import { strToSlug } from '../../../util/seo';
import NewListingCard from '../../elements/new-listing-card/NewListingCard';
import { confirmAlert } from 'react-confirm-alert';

function DashboardListingWrapper(props) {
  const {
    listings,
    onCloseListing,
    onOpenListing,
    onDiscardListing,
    currentUser,
    queryInProgress,
    notify,
    errorsToShow,
    // closeNotification
  } = props;

  useEffect(() => {
    console.log({ errorsToShow });

    if (errorsToShow.length > 0) {
      confirmAlert({
        title: 'You have some warnings to fix',
        message: errorsToShow.join(', '),
        buttons: [
          {
            label: 'Ok',
          },
        ],
      });
    }
  }, [errorsToShow]);

  const { UUID } = sdkTypes;

  const currentProfile = currentUser && currentUser.attributes.profile;

  // console.log(listings);

  const noImage = DefaultListing;

  const getListings = state => {
    if (listings.length > 0) {
      return listings.filter(item => {
        return item.attributes.state === state;
      });
    } else {
      return [];
    }
  };

  const getDescription = text => {
        const length = 100;
        // Decode HTML entities and strip tags before truncating
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const decoded = doc.documentElement.textContent;
        const clean = decoded.replace(/<[^>]*>/g, '');
        return clean.length <= length ? clean : clean.substring(0, length) + '...';
  };

  const historuPush = path => {
    props.history.push(path);
  };

  // const [enableSubButton, setEnableSubButton] = useState(false);
  // const [warnings, setWarnings] = useState([]);
  const intl = useIntl();

  // Listing-limit upgrade modal — opened when the coach is at their
  // tier's active-listing cap. State holds the decision object from
  // listing-service /listing-precheck so the modal can render with the
  // right limit/used/tier copy. null = closed.
  const [upgradeDecision, setUpgradeDecision] = useState(null);

  const closeUpgradeModal = () => setUpgradeDecision(null);
  const handleUpgradeClick = () => {
    setUpgradeDecision(null);
    // Navigate to Coach subscription page where the coach can pick the
    // Verified tier and complete the Chargebee checkout. Could be made
    // one-click in the future by lifting openChargebeePortal to a
    // shared hook, but for now this is the simplest correct path.
    props.history.push('/account/payments/pricing');
  };

  const onAddListingClick = async () => {
    let tempWarnings = [];
    // if (currentUser && !currentUser.attributes.emailVerified) {
    //   tempWarnings.push('Verify your email');
    // }

    if (currentUser.stripeAccount == null) {
      tempWarnings.push('Connect a Stripe account');
      // setEnableSubButton(true);
    }

    const isSubscriptionAvailable = !(
      typeof currentProfile.metadata.subscriptionDetails === 'undefined'
    );

    if (
      currentProfile &&
      (!isSubscriptionAvailable || currentProfile.metadata.subscriptionDetails.subscription <= 0)
    ) {
      tempWarnings.push('Add a Subscription');
      // setEnableSubButton(true);
    } else if (
      isSubscriptionAvailable &&
      parseInt(currentProfile.metadata.subscriptionDetails.expiryDate) < new Date().getTime()
    ) {
      tempWarnings.push(
        `Renew Subscription (Ended on ${formatDateDisplay(
          parseInt(currentProfile.metadata.subscriptionDetails.expiryDate), 'legal'
        )})`
      );
      // setEnableSubButton(true);
    }

    if (!(currentProfile && currentProfile.bio && currentProfile.bio.length > 0)) {
      tempWarnings.push('Please update your bio in your profile');
    }

    if (tempWarnings.length > 0) {
      confirmAlert({
        title: 'You have some warnings to fix',
        message: tempWarnings.join(', '),
        buttons: [{ label: 'Ok' }],
      });
      return;
    }

    // ── Listing-count gate ──────────────────────────────
    // Pre-existing checks above (Stripe / subscription / bio) all
    // passed. Now ask listing-service whether the coach still has room
    // in their tier's active-listing cap. If not, show the upgrade
    // modal instead of advancing to the wizard.
    //
    // Failure modes are intentionally fail-open: if the precheck call
    // errors out (network, service down), we let the coach proceed —
    // the existing /set-premium call after listing creation still
    // mirrors their tier to the listing, and any over-limit listings
    // can be reconciled by a sweep job later. Better UX than blocking
    // legitimate coaches behind a service hiccup.
    const flexUserUUID = currentUser && currentUser.id && currentUser.id.uuid;
    if (!flexUserUUID) {
      props.history.push('/l/new');
      return;
    }

    try {
      const { data: decision } = await axios.post(
        `${config.listingService}listing-precheck`,
        { flexUserUUID },
        { headers: { 'content-type': 'application/json' } }
      );
      if (decision && decision.allowed === false) {
        setUpgradeDecision(decision);
        return;
      }
    } catch (e) {
      console.log('[listing-precheck] precheck failed, allowing proceed:', e.message || e);
    }

    props.history.push('/l/new');
  };

  return (
    <div className={css.wrapper}>
      {/* Page header — Add Ad action lives in the inline CTA card at the end of
          the Active grid, so the top button is intentionally omitted (mirrors
          the Programs page). */}
      <div className={css.pageHeader}>
        <h2 className={css.pageTitle}>Ads</h2>
      </div>
      {/* <h2 className={css.title} style={{ width: 'fit-content' }}>
        My Ads
      </h2> */}
      {/*<h2*/}
      {/*  style={{ width: 'fit-content' }}*/}
      {/*  data-tip= {intl.formatMessage({ id: 'Ads.toolTip' })}*/}
      {/*  className={css.title}*/}
      {/*>*/}
      {/*  My Ads <FontAwesomeIcon icon={faQuestionCircle} className={css.hintIcon}/>*/}
      {/*</h2>*/}
      <div>
        <Tabs selectedTabClassName={css.tabSelected}>
          <TabList className={css.tablist}>
            <Tab className={classnames(css.tab, 'react-tabs__tab')}>Active</Tab>
            <Tab className={classnames(css.tab, 'react-tabs__tab')}>Draft</Tab>
            <Tab className={classnames(css.tab, 'react-tabs__tab')}>Closed</Tab>
          </TabList>

          <div className={css.line}></div>

          <TabPanel>
            <div className={css.listings}>
              {queryInProgress ? (
                <IconSpinner />
              ) : (
                getListings('published').length === 0 && (
                  <p>
                    You don't have any published listings yet. Please create your listing, so that
                    we can advertise your services and clients can find you on Viveka.
                  </p>
                )
              )}
              {getListings('published').map((item, index) => {
                const imgUrl =
                  item.images && item.images.length > 0
                    ? item.images[0].attributes.variants['landscape-crop'].url
                    : noImage;
                return (
                  <NewListingCard
                    key={index}
                    price={
                      item.attributes.price && item.attributes.price.amount
                        ? item.attributes.price.amount / 100
                        : ''
                    }
                    per={item?.attributes?.publicData?.per}
                    title={item.attributes.title}
                    desc={getDescription(item.attributes.description || '')}
                    imgUrl={imgUrl}
                    dashboardEvents={[
                      // Primary actions — left side, V-Coach purple text buttons
                      {
                        name: 'Edit',
                        icon: faEdit,
                        onClick: () => historuPush(`/l/edit/${item.id.uuid}/edit/gallery`),
                        isLeft: true,
                      },
                      {
                        name: 'Share',
                        icon: faShare,
                        onClick: () => {
                          const formattedListingUrl = `/l/${strToSlug(item.attributes.title)}/${
                            item.id.uuid
                          }`;
                          props.history.push(formattedListingUrl);
                        },
                        isLeft: true,
                      },
                      // Destructive — icon-only, demoted to right (matches Programs Delete)
                      {
                        name: 'Close',
                        icon: faLock,
                        onClick: () => onCloseListing(new UUID(item.id.uuid)),
                        iconOnly: true,
                      },
                    ]}
                  />
                );
              })}
              {/* Inline Add CTA — matches the Programs page pattern. Sits at the end of the
                  grid (or alone when no ads yet — gives an empty-state action). */}
              {!queryInProgress && (
                <div
                  className={css.add_card}
                  onClick={() => onAddListingClick()}
                  title="Add a new ad"
                >
                  <FontAwesomeIcon className={css.add_card_icon} icon={faPlusSquare} />
                  <div className={css.add_card_label}>Add Ad</div>
                  <div className={css.add_card_hint}>Create a new ad to attract new clients</div>
                </div>
              )}
            </div>
          </TabPanel>

          <TabPanel>
            <div className={css.listings}>
              {getListings('draft').length === 0 && <p>No listings in draft</p>}
              {getListings('draft').map((item, index) => {
                const imgUrl =
                  item.images && item.images.length > 0
                    ? item.images[0].attributes.variants['landscape-crop'].url
                    : noImage;
                return (
                  <NewListingCard
                    key={index}
                    price={
                      item.attributes.price && item.attributes.price.amount
                        ? item.attributes.price.amount / 100
                        : ''
                    }
                    per={item?.attributes?.publicData?.per}
                    title={item.attributes.title}
                    desc={getDescription(item.attributes.description || '')}
                    imgUrl={imgUrl}
                    dashboardEvents={[
                      // Primary action — left
                      {
                        name: 'Edit',
                        icon: faEdit,
                        onClick: () => historuPush(`/l/edit/${item.id.uuid}/draft/service`),
                        isLeft: true,
                      },
                      // Destructive — icon-only right
                      {
                        name: 'Discard',
                        icon: faTrash,
                        onClick: () => {
                          window.confirm('Are you sure you want to Discard the listing') &&
                            onDiscardListing(new UUID(item.id.uuid));
                        },
                        iconOnly: true,
                      },
                    ]}
                  />
                );
              })}
            </div>
          </TabPanel>

          <TabPanel>
            <div className={css.listings}>
              {getListings('closed').length === 0 && <p>No closed listings</p>}
              {getListings('closed').map((item, index) => {
                const imgUrl =
                  item.images && item.images.length > 0
                    ? item.images[0].attributes.variants['landscape-crop'].url
                    : noImage;
                return (
                  <NewListingCard
                    key={index}
                    price={
                      item.attributes.price && item.attributes.price.amount
                        ? item.attributes.price.amount / 100
                        : ''
                    }
                    per={item?.attributes?.publicData?.per}
                    title={item.attributes.title}
                    desc={getDescription(item.attributes.description || '')}
                    imgUrl={imgUrl}
                    dashboardEvents={[
                      // Both primary on left — Activate is a positive action, no destructive in the closed tab
                      {
                        name: 'Edit',
                        icon: faEdit,
                        onClick: () => historuPush(`/l/edit/${item.id.uuid}/edit/gallery`),
                        isLeft: true,
                      },
                      {
                        name: 'Activate',
                        icon: faLockOpen,
                        onClick: () => {
                          onOpenListing(new UUID(item.id.uuid));
                        },
                        isLeft: true,
                      },
                    ]}
                  />
                );
              })}
            </div>
          </TabPanel>
        </Tabs>
      </div>

      {/* Upgrade-required popup shown when listing-precheck returns
          allowed=false. Mounts at component scope so backdrop covers
          the whole wrapper. The decision object carries tier, limit,
          used, and the required-tier name for accurate copy. */}
      <UpgradeRequiredModal
        isOpen={!!upgradeDecision}
        onClose={closeUpgradeModal}
        onUpgrade={handleUpgradeClick}
        featureName="create another active listing"
        currentTierName={upgradeDecision && upgradeDecision.tierName}
        requiredTierName={upgradeDecision && upgradeDecision.requiredTierName}
        limit={upgradeDecision && upgradeDecision.limit}
        used={upgradeDecision && upgradeDecision.used}
        reason={upgradeDecision && upgradeDecision.reason}
      />
    </div>
  );
}

const mapStateToProps = state => {
  const { notification } = state.utility;

  return {
    notification,
  };
};

const mapDispatchToProps = dispatch => ({
  notify: data => {
    dispatch(showNotification(data));
  },

  closeNotification: () => {
    dispatch(closeNotification());
  },
});

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(DashboardListingWrapper);
